const closeButtonLabel = "Zavřít";
const csCZ = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  csCZ as default
};
